import FreeText from '@algbra/ui/components/FreeText/FreeText'
import { Column, Container, Row } from '@algbra/ui/components/Grid/Grid'
import Heading from '@algbra/ui/components/Heading/Heading'
import Icon from '@algbra/ui/components/Icon/Icon'
import Permalink from '@algbra/ui/components/Permalink/Permalink'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { getIconByName, IconNameType } from '@algbra/ui/icons'
import { map } from 'rambdax'
import React, { ReactNode } from 'react'
import styles from './MeetCommunity.module.scss'

export type CommunityLink = {
  id: string
  title: string
  description: ReactNode
  iconType: IconNameType
  url: string
}

export type ZoneMeetCommunityProps = {
  __typename: 'StrapiGQL_ComponentZonesMeetCommunity'
  title: ReactNode
  communityLinks?: CommunityLink[]
}
export default function ZoneMeetCommunity(props: ZoneMeetCommunityProps) {
  const { title, communityLinks } = props
  return (
    <Whitespace type="md">
      <Container className={styles.meetCommunity}>
        <Row>
          <Column size={12} sm={6}>
            <Heading level={2} type="xl" className={styles.title}>
              {title}
            </Heading>
          </Column>
          <Column size={12} sm={6}>
            <div className={styles.options}>
              {map(
                ({ id, title, description, iconType, url }) => (
                  <Permalink
                    isExternal={true}
                    key={`link-${id}`}
                    to={url}
                    isBlank={true}
                    className={styles.link}
                  >
                    <Row className={styles.item}>
                      <Column auto={true} className={styles.iconBox}>
                        <Icon
                          icon={getIconByName(iconType)}
                          size={30}
                          className={styles.icon}
                        />
                      </Column>
                      <Column className={styles.text}>
                        <Heading level={3} type="sm" className={styles.title}>
                          {title}{' '}
                          <Icon
                            icon={getIconByName('arrow-right')}
                            size={24}
                            className={styles.arrow}
                          />
                        </Heading>
                        {description && (
                          <FreeText color="secondary" innerHTML={description}>
                            {description}
                          </FreeText>
                        )}
                      </Column>
                    </Row>
                  </Permalink>
                ),
                communityLinks || []
              )}
            </div>
          </Column>
        </Row>
      </Container>
    </Whitespace>
  )
}
